import { Box } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import GoBack from 'components/GoBack'
import FitContentPaper from 'components/Paper/FitContentPaper'
import { FormikHelpers } from 'formik'
import useRestricter from 'hooks/useRestricter'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { selectCurrentTempleStaffProfiles, staffProfileListThunk } from 'store/reducers/temple/staffProfileSlice'
import {
    selectStaffTimeOffById,
    selectStaffTimeOffStatus,
    staffTimeOffRetrieveThunk,
    staffTimeOffUpdateThunk,
} from 'store/reducers/temple/staffTimeOffSlice'
import { StaffTimeOffPayloadType } from 'types/api/temple'
import { getFieldErrors } from 'utils/api'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormStaffTimeOff from './FormStaffTimeOff'

interface RouteParams {
    id: string
}

const EditStaffTimeOff: React.FC<RouteConfigComponentProps<RouteParams>> = props => {
    const { id } = props.match.params
    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const api = useAppSelector(selectStaffTimeOffStatus)
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const timeOff = useAppSelector(state => selectStaffTimeOffById(state, id))
    const hasEditPermission = useRestricter(PERMISSIONS.CHANGE, RESTRICTED_PATHS.STAFF_TIME_OFF)

    useEffect(() => {
        dispatch(staffProfileListThunk({}))
        dispatch(staffTimeOffRetrieveThunk({ id }))
    }, [dispatch, id])

    const handleSubmit = (data: StaffTimeOffPayloadType, actions: FormikHelpers<StaffTimeOffPayloadType>) => {
        dispatch(staffTimeOffUpdateThunk({ id, data }))
            .then(unwrapResult)
            .then(response => enqueueSnackbar(`Time off updated for ${response.staffName}`, { variant: 'success' }))
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) => actions.setFieldError(key, value))
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!hasEditPermission) return null

    return (
        <GoBack {...props}>
            <FitContentPaper>
                <Box component='h4' mb={4}>Edit Staff Time Off</Box>
                <FormStaffTimeOff
                    initialValues={timeOff}
                    profiles={profiles}
                    buttonLabel='Update'
                    api={api}
                    onSubmit={handleSubmit}
                />
            </FitContentPaper>
        </GoBack>
    )
}

export default EditStaffTimeOff
